import { useEffect } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { trackers } from '../../config/withEventTracking';

export const useNotificationTracking = (trackEvent, pageName) => {
  const location = useLocation();
  const history = useHistory();

  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    const comesFromNotification = urlParams.get('comesFromNotification');
    const notificationName = urlParams.get('notificationName');
    const companyId = urlParams.get('companyId');

    if (comesFromNotification === 'true' && notificationName && companyId && trackEvent) {
      trackEvent(`notification_${pageName}_visit`, {
        notificationName: notificationName,
        companyId: companyId,
        source: 'notification',
        targetPage: pageName,
        comesFromNotification: true
      }, false, [trackers.MIXPANEL]);

      const newUrl = new URL(window.location);
      newUrl.searchParams.delete('comesFromNotification');
      newUrl.searchParams.delete('notificationName');
      newUrl.searchParams.delete('companyId');
      history.replace(newUrl.pathname + newUrl.search);
    }
  }, [location.search, trackEvent, pageName, history]);
};
